// // import React, { useState, useEffect } from "react";
// // import {
// //   collection,
// //   getDocs,
// //   doc,
// //   updateDoc,
// //   deleteDoc,
// // } from "firebase/firestore";
// // import { db } from "../../firebase";
// // import Swal from "sweetalert2";
// // import css from "./videoReviews.module.css"; // Додано CSS для стилізації

// // const VideoReviews = () => {
// //   const [videos, setVideos] = useState([]);
// //   const [editingVideo, setEditingVideo] = useState(null);
// //   const [updatedData, setUpdatedData] = useState({});
// //   const [books, setBooks] = useState([]);
// //   const [ageCategories, setAgeCategories] = useState([]);

// //   useEffect(() => {
// //     fetchVideos();
// //     fetchBooks();
// //     fetchAgeCategories();
// //   }, []);

// //   const fetchVideos = async () => {
// //     try {
// //       const videoCollection = await getDocs(collection(db, "videoV"));
// //       const videoList = videoCollection.docs.map((doc) => ({
// //         id: doc.id,
// //         ...doc.data(),
// //       }));
// //       setVideos(videoList);
// //     } catch (error) {
// //       console.error("❌ Помилка отримання відео:", error);
// //     }
// //   };

// //   const fetchBooks = async () => {
// //     try {
// //       const booksCollection = await getDocs(collection(db, "product"));
// //       const booksList = booksCollection.docs.map((doc) => ({
// //         uid: doc.id,
// //         ...doc.data(),
// //       }));
// //       setBooks(booksList);
// //     } catch (error) {
// //       console.error("❌ Помилка отримання книг:", error);
// //     }
// //   };

// //   const fetchAgeCategories = async () => {
// //     try {
// //       const querySnapshot = await getDocs(collection(db, "filters"));
// //       const filtersData = querySnapshot.docs.map((doc) => doc.data());

// //       const ageFilter = filtersData.find(
// //         (filter) => filter.transliter === "yearGroup"
// //       );

// //       if (ageFilter) {
// //         setAgeCategories(ageFilter.list);
// //       }
// //     } catch (error) {
// //       console.error("❌ Помилка отримання вікових груп:", error);
// //     }
// //   };

// //   const handleEdit = (video) => {
// //     setEditingVideo(video.id);
// //     setUpdatedData({ ...video, ageCategories: video.ageCategories || [] });
// //   };

// //   const handleUpdate = async () => {
// //     if (!updatedData.videoName || !updatedData.videoDesc) {
// //       Swal.fire({
// //         icon: "error",
// //         title: "Помилка",
// //         text: "Назва відео та опис є обов'язковими!",
// //       });
// //       return;
// //     }

// //     try {
// //       const videoDoc = doc(db, "videoV", editingVideo);
// //       await updateDoc(videoDoc, updatedData);
// //       Swal.fire({
// //         icon: "success",
// //         title: "Успішно",
// //         text: "Відео оновлено!",
// //       });
// //       setEditingVideo(null);
// //       fetchVideos();
// //     } catch (error) {
// //       console.error("❌ Помилка оновлення відео:", error);
// //       Swal.fire({
// //         icon: "error",
// //         title: "Помилка",
// //         text: "Не вдалося оновити відео.",
// //       });
// //     }
// //   };

// //   const handleDelete = async (videoId) => {
// //     const result = await Swal.fire({
// //       title: "Ви впевнені?",
// //       text: "Це відео буде видалене назавжди!",
// //       icon: "warning",
// //       showCancelButton: true,
// //       confirmButtonColor: "#d33",
// //       cancelButtonColor: "#3085d6",
// //       confirmButtonText: "Так, видалити!",
// //       cancelButtonText: "Скасувати",
// //     });

// //     if (result.isConfirmed) {
// //       try {
// //         await deleteDoc(doc(db, "videoV", videoId));
// //         Swal.fire("Видалено!", "Відео успішно видалене.", "success");
// //         fetchVideos();
// //       } catch (error) {
// //         console.error("❌ Помилка видалення відео:", error);
// //         Swal.fire("Помилка!", "Не вдалося видалити відео.", "error");
// //       }
// //     }
// //   };

// //   const handleAddAgeCategory = () => {
// //     setUpdatedData((prev) => ({
// //       ...prev,
// //       ageCategories: [...prev.ageCategories, ""],
// //     }));
// //   };

// //   const handleAgeChange = (index, value) => {
// //     const updatedAges = [...updatedData.ageCategories];
// //     updatedAges[index] = value;
// //     setUpdatedData({ ...updatedData, ageCategories: updatedAges });
// //   };

// //   const handleRemoveAgeCategory = (index) => {
// //     const updatedAges = updatedData.ageCategories.filter((_, i) => i !== index);
// //     setUpdatedData({ ...updatedData, ageCategories: updatedAges });
// //   };

// //   return (
// //     <div className="video-container">
// //       <h2>📹 Відео Відгуки</h2>
// //       {videos.length === 0 ? (
// //         <p>⏳ Завантаження відео...</p>
// //       ) : (
// //         <div>
// //           {videos.map((video) => (
// //             <div key={video.id} className="video-card">
// //               {editingVideo === video.id ? (
// //                 <div className="edit-form">
// //                   <label>Назва відео:</label>
// //                   <input
// //                     type="text"
// //                     value={updatedData.videoName}
// //                     onChange={(e) =>
// //                       setUpdatedData({
// //                         ...updatedData,
// //                         videoName: e.target.value,
// //                       })
// //                     }
// //                   />

// //                   <label>Опис відео:</label>
// //                   <textarea
// //                     value={updatedData.videoDesc}
// //                     onChange={(e) =>
// //                       setUpdatedData({
// //                         ...updatedData,
// //                         videoDesc: e.target.value,
// //                       })
// //                     }
// //                   />

// //                   <label>Вікові категорії:</label>
// //                   {updatedData.ageCategories.map((age, index) => (
// //                     <div key={index} className="age-category">
// //                       <select
// //                         value={age}
// //                         onChange={(e) => handleAgeChange(index, e.target.value)}
// //                       >
// //                         <option value="">Оберіть категорію</option>
// //                         {ageCategories.map((category, idx) => (
// //                           <option key={idx} value={category}>
// //                             {category}
// //                           </option>
// //                         ))}
// //                       </select>
// //                       <button onClick={() => handleRemoveAgeCategory(index)}>
// //                         🗑
// //                       </button>
// //                     </div>
// //                   ))}
// //                   <button onClick={handleAddAgeCategory}>
// //                     ➕ Додати категорію
// //                   </button>

// //                   <button onClick={handleUpdate}>💾 Зберегти</button>
// //                   <button onClick={() => setEditingVideo(null)}>
// //                     ❌ Скасувати
// //                   </button>
// //                 </div>
// //               ) : (
// //                 <div>
// //                   <h3>{video.videoName}</h3>
// //                   <p>{video.videoDesc}</p>
// //                   <p>📚 Книга: {video.bookName || "Не вказано"}</p>
// //                   <p>🎥 ID Відео: {video.videoId}</p>
// //                   <p>
// //                     🗂 Вікові категорії:{" "}
// //                     {video.ageCategories?.join(", ") || "Не вказано"}
// //                   </p>

// //                   {video.videoId && (
// //                     <iframe
// //                       width="300"
// //                       height="200"
// //                       src={`https://www.youtube.com/embed/${video.videoId}`}
// //                       title="YouTube video"
// //                       frameBorder="0"
// //                       allowFullScreen
// //                     ></iframe>
// //                   )}

// //                   <div>
// //                     <button onClick={() => handleEdit(video)}>
// //                       ✏️ Редагувати
// //                     </button>
// //                     <button onClick={() => handleDelete(video.id)}>
// //                       🗑 Видалити
// //                     </button>
// //                   </div>
// //                 </div>
// //               )}
// //             </div>
// //           ))}
// //         </div>
// //       )}
// //     </div>
// //   );
// // };

// // export default VideoReviews;
// import React, { useState, useEffect } from "react";
// import {
//   collection,
//   getDocs,
//   doc,
//   updateDoc,
//   deleteDoc,
// } from "firebase/firestore";
// import { db } from "../../firebase";
// import Swal from "sweetalert2";
// import css from "./videoReviews.module.css";

// const VideoReviews = () => {
//   const [videos, setVideos] = useState([]);
//   const [editingVideo, setEditingVideo] = useState(null);
//   const [updatedData, setUpdatedData] = useState({});
//   const [books, setBooks] = useState([]);
//   const [ageCategories, setAgeCategories] = useState([]);

//   useEffect(() => {
//     fetchVideos();
//     fetchBooks();
//     fetchAgeCategories();
//   }, []);

//   const fetchVideos = async () => {
//     try {
//       const videoCollection = await getDocs(collection(db, "videoV"));
//       const videoList = videoCollection.docs.map((doc) => ({
//         id: doc.id,
//         ...doc.data(),
//       }));
//       setVideos(videoList);
//     } catch (error) {
//       console.error("❌ Помилка отримання відео:", error);
//     }
//   };

//   const fetchBooks = async () => {
//     try {
//       const booksCollection = await getDocs(collection(db, "product"));
//       const booksList = booksCollection.docs.map((doc) => ({
//         uid: doc.id,
//         ...doc.data(),
//       }));
//       setBooks(booksList);
//     } catch (error) {
//       console.error("❌ Помилка отримання книг:", error);
//     }
//   };

//   const fetchAgeCategories = async () => {
//     try {
//       const querySnapshot = await getDocs(collection(db, "filters"));
//       const filtersData = querySnapshot.docs.map((doc) => doc.data());

//       const ageFilter = filtersData.find(
//         (filter) => filter.transliter === "yearGroup"
//       );

//       if (ageFilter) {
//         setAgeCategories(ageFilter.list);
//       }
//     } catch (error) {
//       console.error("❌ Помилка отримання вікових груп:", error);
//     }
//   };

//   const handleEdit = (video) => {
//     setEditingVideo(video.id);
//     setUpdatedData({ ...video, ageCategories: video.ageCategories || [] });
//   };

//   const handleUpdate = async () => {
//     if (!updatedData.videoName || !updatedData.videoDesc) {
//       Swal.fire({
//         icon: "error",
//         title: "Помилка",
//         text: "Назва відео та опис є обов'язковими!",
//       });
//       return;
//     }

//     try {
//       const videoDoc = doc(db, "videoV", editingVideo);
//       await updateDoc(videoDoc, updatedData);
//       Swal.fire({
//         icon: "success",
//         title: "Успішно",
//         text: "Відео оновлено!",
//       });
//       setEditingVideo(null);
//       fetchVideos();
//     } catch (error) {
//       console.error("❌ Помилка оновлення відео:", error);
//       Swal.fire({
//         icon: "error",
//         title: "Помилка",
//         text: "Не вдалося оновити відео.",
//       });
//     }
//   };

//   const handleDelete = async (videoId) => {
//     const result = await Swal.fire({
//       title: "Ви впевнені?",
//       text: "Це відео буде видалене назавжди!",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#d33",
//       cancelButtonColor: "#3085d6",
//       confirmButtonText: "Так, видалити!",
//       cancelButtonText: "Скасувати",
//     });

//     if (result.isConfirmed) {
//       try {
//         await deleteDoc(doc(db, "videoV", videoId));
//         Swal.fire("Видалено!", "Відео успішно видалене.", "success");
//         fetchVideos();
//       } catch (error) {
//         console.error("❌ Помилка видалення відео:", error);
//         Swal.fire("Помилка!", "Не вдалося видалити відео.", "error");
//       }
//     }
//   };

//   const handleAddAgeCategory = () => {
//     setUpdatedData((prev) => ({
//       ...prev,
//       ageCategories: [...prev.ageCategories, ""],
//     }));
//   };

//   const handleAgeChange = (index, value) => {
//     const updatedAges = [...updatedData.ageCategories];
//     updatedAges[index] = value;
//     setUpdatedData({ ...updatedData, ageCategories: updatedAges });
//   };

//   const handleRemoveAgeCategory = (index) => {
//     const updatedAges = updatedData.ageCategories.filter((_, i) => i !== index);
//     setUpdatedData({ ...updatedData, ageCategories: updatedAges });
//   };

//   return (
//     <div className="video-container">
//       <h2>📹 Відео Відгуки</h2>
//       {videos.length === 0 ? (
//         <p>⏳ Завантаження відео...</p>
//       ) : (
//         <div>
//           {videos.map((video) => (
//             <div key={video.id} className="video-card">
//               {editingVideo === video.id ? (
//                 <div className="edit-form">
//                   <label>Назва відео:</label>
//                   <input
//                     type="text"
//                     value={updatedData.videoName}
//                     onChange={(e) =>
//                       setUpdatedData({
//                         ...updatedData,
//                         videoName: e.target.value,
//                       })
//                     }
//                   />

//                   <label>Опис відео:</label>
//                   <textarea
//                     value={updatedData.videoDesc}
//                     onChange={(e) =>
//                       setUpdatedData({
//                         ...updatedData,
//                         videoDesc: e.target.value,
//                       })
//                     }
//                   />

//                   <label>ID Відео (YouTube):</label>
//                   <input
//                     type="text"
//                     value={updatedData.videoId}
//                     onChange={(e) =>
//                       setUpdatedData({
//                         ...updatedData,
//                         videoId: e.target.value,
//                       })
//                     }
//                   />

//                   <label>Вікові категорії:</label>
//                   {updatedData.ageCategories.map((age, index) => (
//                     <div key={index} className="age-category">
//                       <select
//                         value={age}
//                         onChange={(e) => handleAgeChange(index, e.target.value)}
//                       >
//                         <option value="">Оберіть категорію</option>
//                         {ageCategories.map((category, idx) => (
//                           <option key={idx} value={category}>
//                             {category}
//                           </option>
//                         ))}
//                       </select>
//                       <button onClick={() => handleRemoveAgeCategory(index)}>
//                         🗑
//                       </button>
//                     </div>
//                   ))}
//                   <button onClick={handleAddAgeCategory}>
//                     ➕ Додати категорію
//                   </button>

//                   <button onClick={handleUpdate}>💾 Зберегти</button>
//                   <button onClick={() => setEditingVideo(null)}>
//                     ❌ Скасувати
//                   </button>
//                 </div>
//               ) : (
//                 <div>
//                   <h3>{video.videoName}</h3>
//                   <p>{video.videoDesc}</p>
//                   <p>📚 Книга: {video.bookName || "Не вказано"}</p>
//                   <p>🎥 ID Відео: {video.videoId}</p>
//                   <p>
//                     🗂 Вікові категорії:{" "}
//                     {video.ageCategories?.join(", ") || "Не вказано"}
//                   </p>

//                   {video.videoId && (
//                     <iframe
//                       width="300"
//                       height="200"
//                       src={`https://www.youtube.com/embed/${video.videoId}`}
//                       title="YouTube video"
//                       frameBorder="0"
//                       allowFullScreen
//                     ></iframe>
//                   )}

//                   <div>
//                     <button onClick={() => handleEdit(video)}>
//                       ✏️ Редагувати
//                     </button>
//                     <button onClick={() => handleDelete(video.id)}>
//                       🗑 Видалити
//                     </button>
//                   </div>
//                 </div>
//               )}
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// export default VideoReviews;
import React, { useEffect, useMemo, useState } from "react";
import {
  collection,
  deleteDoc,
  doc,
  getDocs,
  updateDoc,
} from "firebase/firestore";
import Swal from "sweetalert2";

import { db } from "../../firebase";
import css from "./videoReviews.module.css";

const VideoReviews = () => {
  const [videos, setVideos] = useState([]);
  const [books, setBooks] = useState([]);
  const [ageCategories, setAgeCategories] = useState([]);

  const [editingVideoId, setEditingVideoId] = useState(null);
  const [updatedData, setUpdatedData] = useState({});

  const [searchValue, setSearchValue] = useState("");
  const [sortDirection, setSortDirection] = useState("asc");

  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    const loadData = async () => {
      setIsLoading(true);

      try {
        await Promise.all([fetchVideos(), fetchBooks(), fetchAgeCategories()]);
      } finally {
        setIsLoading(false);
      }
    };

    loadData();
  }, []);

  const fetchVideos = async () => {
    try {
      const snapshot = await getDocs(collection(db, "videoV"));

      const videoList = snapshot.docs.map((videoDoc) => ({
        id: videoDoc.id,
        ...videoDoc.data(),
      }));

      setVideos(videoList);
    } catch (error) {
      console.error("Помилка отримання відео:", error);

      Swal.fire({
        icon: "error",
        title: "Помилка",
        text: "Не вдалося завантажити відео.",
      });
    }
  };

  const fetchBooks = async () => {
    try {
      const snapshot = await getDocs(collection(db, "product"));

      const booksList = snapshot.docs.map((bookDoc) => ({
        uid: bookDoc.id,
        ...bookDoc.data(),
      }));

      setBooks(booksList);
    } catch (error) {
      console.error("Помилка отримання книг:", error);
    }
  };

  const fetchAgeCategories = async () => {
    try {
      const snapshot = await getDocs(collection(db, "filters"));

      const filters = snapshot.docs.map((filterDoc) => ({
        id: filterDoc.id,
        ...filterDoc.data(),
      }));

      const ageFilter = filters.find(
        (filter) => filter.transliter === "yearGroup",
      );

      if (ageFilter && Array.isArray(ageFilter.list)) {
        const sortedCategories = [...ageFilter.list].sort((a, b) =>
          String(a).localeCompare(String(b), "uk-UA", {
            sensitivity: "base",
            numeric: true,
          }),
        );

        setAgeCategories(sortedCategories);
      }
    } catch (error) {
      console.error("Помилка отримання вікових категорій:", error);
    }
  };

  const getBookName = (book) => {
    return (
      book?.bookName ||
      book?.name ||
      book?.title ||
      book?.productName ||
      book?.zag ||
      "Книга без назви"
    );
  };

  const sortedBooks = useMemo(() => {
    return [...books].sort((a, b) =>
      getBookName(a).localeCompare(getBookName(b), "uk-UA", {
        sensitivity: "base",
        numeric: true,
        ignorePunctuation: true,
      }),
    );
  }, [books]);

  const displayedVideos = useMemo(() => {
    const normalizedSearch = searchValue.trim().toLocaleLowerCase("uk-UA");

    const filteredVideos = videos.filter((video) => {
      if (!normalizedSearch) {
        return true;
      }

      const searchableText = [
        video.videoName,
        video.videoDesc,
        video.bookName,
        video.videoId,
        ...(Array.isArray(video.ageCategories) ? video.ageCategories : []),
      ]
        .filter(Boolean)
        .join(" ")
        .toLocaleLowerCase("uk-UA");

      return searchableText.includes(normalizedSearch);
    });

    return [...filteredVideos].sort((a, b) => {
      const firstName = String(a.videoName || "").trim();
      const secondName = String(b.videoName || "").trim();

      const comparison = firstName.localeCompare(secondName, "uk-UA", {
        sensitivity: "base",
        numeric: true,
        ignorePunctuation: true,
      });

      return sortDirection === "asc" ? comparison : -comparison;
    });
  }, [videos, searchValue, sortDirection]);

  const handleEdit = (video) => {
    const matchingBook = books.find(
      (book) => getBookName(book) === video.bookName,
    );

    setEditingVideoId(video.id);

    setUpdatedData({
      ...video,
      videoName: video.videoName || "",
      videoDesc: video.videoDesc || "",
      videoId: video.videoId || "",
      bookId: video.bookId || matchingBook?.uid || "",
      bookName: video.bookName || "",
      ageCategories: Array.isArray(video.ageCategories)
        ? [...video.ageCategories]
        : [],
    });
  };

  const handleCancelEdit = () => {
    setEditingVideoId(null);
    setUpdatedData({});
  };

  const handleFieldChange = (field, value) => {
    setUpdatedData((previousData) => ({
      ...previousData,
      [field]: value,
    }));
  };

  const handleBookChange = (bookId) => {
    const selectedBook = books.find((book) => book.uid === bookId);

    setUpdatedData((previousData) => ({
      ...previousData,
      bookId,
      bookName: selectedBook ? getBookName(selectedBook) : "",
    }));
  };

  const handleAddAgeCategory = () => {
    setUpdatedData((previousData) => ({
      ...previousData,
      ageCategories: [...(previousData.ageCategories || []), ""],
    }));
  };

  const handleAgeChange = (index, value) => {
    setUpdatedData((previousData) => {
      const updatedAgeCategories = [...(previousData.ageCategories || [])];

      updatedAgeCategories[index] = value;

      return {
        ...previousData,
        ageCategories: updatedAgeCategories,
      };
    });
  };

  const handleRemoveAgeCategory = (index) => {
    setUpdatedData((previousData) => ({
      ...previousData,
      ageCategories: (previousData.ageCategories || []).filter(
        (_, categoryIndex) => categoryIndex !== index,
      ),
    }));
  };

  const handleUpdate = async () => {
    const videoName = String(updatedData.videoName || "").trim();
    const videoDesc = String(updatedData.videoDesc || "").trim();
    const videoId = String(updatedData.videoId || "").trim();

    if (!videoName || !videoDesc) {
      Swal.fire({
        icon: "error",
        title: "Заповніть обов’язкові поля",
        text: "Назва відео та опис є обов’язковими.",
      });

      return;
    }

    setIsSaving(true);

    try {
      const normalizedAgeCategories = [
        ...new Set(
          (updatedData.ageCategories || [])
            .map((category) => String(category).trim())
            .filter(Boolean),
        ),
      ];

      const { id, ...dataWithoutDocumentId } = updatedData;

      const dataForUpdate = {
        ...dataWithoutDocumentId,
        videoName,
        videoDesc,
        videoId,
        bookId: updatedData.bookId || "",
        bookName: String(updatedData.bookName || "").trim(),
        ageCategories: normalizedAgeCategories,
      };

      await updateDoc(doc(db, "videoV", editingVideoId), dataForUpdate);

      setVideos((previousVideos) =>
        previousVideos.map((video) =>
          video.id === editingVideoId
            ? {
                ...video,
                ...dataForUpdate,
              }
            : video,
        ),
      );

      setEditingVideoId(null);
      setUpdatedData({});

      Swal.fire({
        icon: "success",
        title: "Відео оновлено",
        text: "Зміни успішно збережено.",
        timer: 1800,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error("Помилка оновлення відео:", error);

      Swal.fire({
        icon: "error",
        title: "Помилка",
        text: "Не вдалося оновити відео.",
      });
    } finally {
      setIsSaving(false);
    }
  };

  const handleDelete = async (videoId) => {
    const result = await Swal.fire({
      title: "Видалити відео?",
      text: "Цю дію неможливо буде скасувати.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#64748b",
      confirmButtonText: "Так, видалити",
      cancelButtonText: "Скасувати",
      reverseButtons: true,
    });

    if (!result.isConfirmed) {
      return;
    }

    try {
      await deleteDoc(doc(db, "videoV", videoId));

      setVideos((previousVideos) =>
        previousVideos.filter((video) => video.id !== videoId),
      );

      if (editingVideoId === videoId) {
        handleCancelEdit();
      }

      Swal.fire({
        icon: "success",
        title: "Відео видалено",
        timer: 1600,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error("Помилка видалення відео:", error);

      Swal.fire({
        icon: "error",
        title: "Помилка",
        text: "Не вдалося видалити відео.",
      });
    }
  };

  return (
    <section className={css.page}>
      <div className={css.container}>
        <header className={css.header}>
          <div>
            <p className={css.eyebrow}>Керування контентом</p>
            <h1 className={css.title}>Відеоогляди</h1>

            <p className={css.subtitle}>
              Редагування відео, книг та вікових категорій.
            </p>
          </div>

          <div className={css.totalBadge}>Всього: {videos.length}</div>
        </header>

        <div className={css.toolbar}>
          <div className={css.searchWrap}>
            <span className={css.searchIcon}>🔎</span>

            <input
              type="search"
              className={css.searchInput}
              value={searchValue}
              onChange={(event) => setSearchValue(event.target.value)}
              placeholder="Пошук за назвою, описом або книгою"
            />

            {searchValue && (
              <button
                type="button"
                className={css.clearSearch}
                onClick={() => setSearchValue("")}
                aria-label="Очистити пошук"
              >
                ×
              </button>
            )}
          </div>

          <label className={css.sortWrap}>
            <span>Сортування</span>

            <select
              className={css.sortSelect}
              value={sortDirection}
              onChange={(event) => setSortDirection(event.target.value)}
            >
              <option value="asc">За назвою: А–Я</option>
              <option value="desc">За назвою: Я–А</option>
            </select>
          </label>
        </div>

        <div className={css.resultsInfo}>
          Знайдено: {displayedVideos.length}
        </div>

        {isLoading ? (
          <div className={css.stateBlock}>
            <div className={css.loader} />
            <p>Завантаження відео...</p>
          </div>
        ) : displayedVideos.length === 0 ? (
          <div className={css.stateBlock}>
            <div className={css.emptyIcon}>🎬</div>
            <h2>Відео не знайдено</h2>
            <p>Спробуйте змінити пошуковий запит.</p>
          </div>
        ) : (
          <div className={css.videoGrid}>
            {displayedVideos.map((video, index) => {
              const isEditing = editingVideoId === video.id;

              return (
                <article
                  key={video.id}
                  className={`${css.videoCard} ${
                    isEditing ? css.videoCardEditing : ""
                  }`}
                >
                  {isEditing ? (
                    <div className={css.editForm}>
                      <div className={css.editFormHeader}>
                        <div>
                          <span className={css.editLabel}>Редагування</span>

                          <h2 className={css.editTitle}>
                            {video.videoName || "Відео без назви"}
                          </h2>
                        </div>

                        <button
                          type="button"
                          className={css.closeButton}
                          onClick={handleCancelEdit}
                          aria-label="Закрити"
                        >
                          ×
                        </button>
                      </div>

                      <div className={css.formGroup}>
                        <label
                          className={css.label}
                          htmlFor={`videoName-${video.id}`}
                        >
                          Назва відео
                          <span className={css.required}>*</span>
                        </label>

                        <input
                          id={`videoName-${video.id}`}
                          type="text"
                          className={css.input}
                          value={updatedData.videoName || ""}
                          onChange={(event) =>
                            handleFieldChange("videoName", event.target.value)
                          }
                        />
                      </div>

                      <div className={css.formGroup}>
                        <label
                          className={css.label}
                          htmlFor={`videoDesc-${video.id}`}
                        >
                          Опис відео
                          <span className={css.required}>*</span>
                        </label>

                        <textarea
                          id={`videoDesc-${video.id}`}
                          className={css.textarea}
                          rows={5}
                          value={updatedData.videoDesc || ""}
                          onChange={(event) =>
                            handleFieldChange("videoDesc", event.target.value)
                          }
                        />
                      </div>

                      <div className={css.formRow}>
                        <div className={css.formGroup}>
                          <label
                            className={css.label}
                            htmlFor={`videoId-${video.id}`}
                          >
                            YouTube ID
                          </label>

                          <input
                            id={`videoId-${video.id}`}
                            type="text"
                            className={css.input}
                            value={updatedData.videoId || ""}
                            onChange={(event) =>
                              handleFieldChange("videoId", event.target.value)
                            }
                            placeholder="ZH0bv5502wE"
                          />
                        </div>

                        <div className={css.formGroup}>
                          <label
                            className={css.label}
                            htmlFor={`book-${video.id}`}
                          >
                            Книга
                          </label>

                          <select
                            id={`book-${video.id}`}
                            className={css.select}
                            value={updatedData.bookId || ""}
                            onChange={(event) =>
                              handleBookChange(event.target.value)
                            }
                          >
                            <option value="">Не вибрано</option>

                            {sortedBooks.map((book) => (
                              <option key={book.uid} value={book.uid}>
                                {getBookName(book)}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className={css.formGroup}>
                        <div className={css.ageHeader}>
                          <label className={css.label}>Вікові категорії</label>

                          <button
                            type="button"
                            className={css.addAgeButton}
                            onClick={handleAddAgeCategory}
                          >
                            + Додати категорію
                          </button>
                        </div>

                        {(updatedData.ageCategories || []).length === 0 ? (
                          <div className={css.emptyCategories}>
                            Категорії не вибрані
                          </div>
                        ) : (
                          <div className={css.ageCategoriesList}>
                            {updatedData.ageCategories.map((age, ageIndex) => (
                              <div
                                key={`${video.id}-${ageIndex}`}
                                className={css.ageCategoryRow}
                              >
                                <select
                                  className={css.select}
                                  value={age}
                                  onChange={(event) =>
                                    handleAgeChange(
                                      ageIndex,
                                      event.target.value,
                                    )
                                  }
                                >
                                  <option value="">Оберіть категорію</option>

                                  {ageCategories.map(
                                    (category, categoryIndex) => (
                                      <option
                                        key={`${category}-${categoryIndex}`}
                                        value={category}
                                      >
                                        {category}
                                      </option>
                                    ),
                                  )}
                                </select>

                                <button
                                  type="button"
                                  className={css.removeAgeButton}
                                  onClick={() =>
                                    handleRemoveAgeCategory(ageIndex)
                                  }
                                  aria-label="Видалити категорію"
                                >
                                  ×
                                </button>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>

                      <div className={css.formActions}>
                        <button
                          type="button"
                          className={css.cancelButton}
                          onClick={handleCancelEdit}
                          disabled={isSaving}
                        >
                          Скасувати
                        </button>

                        <button
                          type="button"
                          className={css.saveButton}
                          onClick={handleUpdate}
                          disabled={isSaving}
                        >
                          {isSaving ? "Збереження..." : "Зберегти зміни"}
                        </button>
                      </div>
                    </div>
                  ) : (
                    <>
                      <div className={css.videoPreview}>
                        {video.videoId ? (
                          <iframe
                            src={`https://www.youtube.com/embed/${video.videoId}`}
                            title={video.videoName || "YouTube video"}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            loading="lazy"
                          />
                        ) : (
                          <div className={css.noVideo}>
                            <span>▶</span>
                            <p>YouTube ID не вказано</p>
                          </div>
                        )}
                      </div>

                      <div className={css.cardContent}>
                        <div className={css.cardTop}>
                          <h2 className={css.videoName}>
                            {video.videoName || "Відео без назви"}
                          </h2>

                          <span className={css.videoNumber}>#{index + 1}</span>
                        </div>

                        <p className={css.videoDescription}>
                          {video.videoDesc || "Опис не вказано"}
                        </p>

                        <div className={css.metaList}>
                          <div className={css.metaItem}>
                            <span className={css.metaLabel}>Книга</span>

                            <span className={css.metaValue}>
                              {video.bookName || "Не вказано"}
                            </span>
                          </div>

                          <div className={css.metaItem}>
                            <span className={css.metaLabel}>YouTube ID</span>

                            <span className={css.codeValue}>
                              {video.videoId || "Не вказано"}
                            </span>
                          </div>
                        </div>

                        <div className={css.categoriesBlock}>
                          <span className={css.categoriesTitle}>
                            Вікові категорії
                          </span>

                          <div className={css.categoryChips}>
                            {video.ageCategories?.length ? (
                              video.ageCategories.map(
                                (category, categoryIndex) => (
                                  <span
                                    key={`${category}-${categoryIndex}`}
                                    className={css.categoryChip}
                                  >
                                    {category}
                                  </span>
                                ),
                              )
                            ) : (
                              <span className={css.emptyChip}>Не вказано</span>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className={css.cardActions}>
                        <button
                          type="button"
                          className={css.editButton}
                          onClick={() => handleEdit(video)}
                        >
                          Редагувати
                        </button>

                        <button
                          type="button"
                          className={css.deleteButton}
                          onClick={() => handleDelete(video.id)}
                        >
                          Видалити
                        </button>
                      </div>
                    </>
                  )}
                </article>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
};

export default VideoReviews;
